export default __webpack_public_path__ + "347fe51183a1744e2cdbb16dacaa8aa4.png";